<template>
  <div class="holding-page">
    <h1 class="heading">A STATE OF BLISS</h1>
    <h2 class="sub-heading">SPRING SUMMER 2023</h2>

    <div class="clock">
      <p v-if="isLoggedIn" class="message">{{ text }}</p>
      <CountdownClock :end="endDate" />
      <Button
        v-if="!isLoggedIn"
        tag="a"
        href="/account/login?return_url=/"
        theme="white"
        class="login-button"
      >
        Login for early access
      </Button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button.vue";
import CountdownClock from "@/components/CountdownClock.vue";
export default {
  name: "HoldingPage",
  components: {
    Button,
    CountdownClock,
  },
  inject: ["mq"],
  props: {
    text: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
  },
  methods: {
    ...mapActions("app", ["setSlideLogin"]),
  },
};
</script>

<style lang="scss" scoped>
.holding-page {
  align-items: center;
  background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/SH_05_1533_copy_2_1.jpg?v=1686146737");
  background-position: center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  margin-top: -83px;
  z-index: 2;
  position: relative;
  overflow: hidden;
  text-align: center;
  @include respond-above(md) {
    background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/SH_02_0331_copy_1.jpg?v=1686146256");
    background-position: center center;
    background-size: cover;
  }

  .template-index & {
    margin-top: -34px;

    @include respond-above(md) {
      margin-top: -36px;
    }
  }
}

.clock {
  text-align: center;

  .login-button {
    display: inline-block;
    margin-bottom: 50px;

    @include respond-above(md) {
      margin-bottom: 75px;
    }
  }
}

.heading {
  font-family: $heading-font-family;
  font-weight: 500;
  font-size: 40px;
  text-transform: uppercase;
  color: $color-white;
  margin: 0 0 10px 0;

  @include respond-above(md) {
    font-size: 80px;
  }
}

.sub-heading {
  font-family: $heading-font-family;
  font-weight: 500;
  font-size: 20px;
  text-transform: uppercase;
  color: $color-white;
  margin: 0 0 50px 0;

  @include respond-above(md) {
    font-size: 20px;
  }
}

.message {
  color: $color-white;
  margin: 0 0 20px 0;
}
</style>
